import React, { useMemo } from "react"
import { Container } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import {
  formatAmount,
  getIcdRequestStatus,
  getTableSortingHeaderIcon,
} from "helpers/common"

const InvestmentScheduleSearchResults = ({ data = [] }) => {
  const columns = useMemo(() => [
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Reference No."),
      accessorKey: "unique_code",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-number">{row?.original.unique_code}</div>
      ),
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Date of Investment"),
      accessorKey: "approved_at",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <>{moment(row?.original.approved_at).format("D MMM YYYY")}</>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Amount (₹)"),
      accessorKey: "amount",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <div>₹ {formatAmount(row?.original.amount)}</div>,
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, "Interest"),
      accessorKey: "interest_rate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">{row?.original.interest_rate} %</div>
      ),
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Date of Repayment"),
      accessorKey: "repayment_date",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">
          {row?.original.repayment_date
            ? moment(row?.original.repayment_date).format("D MMM YYYY")
            : ""}
        </div>
      ),
    },
    {
      header: () => <div className="flex items-center gap-2">Status</div>,
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }) => (
        <div className="code-status">
          {getIcdRequestStatus(row?.original.status)}
        </div>
      ),
    },
  ])

  return (
    <React.Fragment>
      <Container fluid>
        <TableContainer
          count={data.length}
          filters={{ page: 1, pageSize: 100 }}
          columns={columns}
          data={data}
          isGlobalFilter={false}
          isCustomPageSize={false}
          isPagination={false}
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </Container>
    </React.Fragment>
  )
}

export default InvestmentScheduleSearchResults
